const state = {
  scratchData: {},
  scratchActive: false,
};

const mutations = {
  CHANGE_SCRATCH_CONTENT(state, scratchObj) {
    state.scratchData = scratchObj;
  },
  CHANGE_SCRATCH_ACTIVE(state, scratchActive) {
    state.scratchActive = scratchActive;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  scratchData: (state) => {
    return state.scratchData;
  },
  scratchActive: (state) => {
    return state.scratchActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
